<template>
  <div id="app" class="w-per100 column a-center">
    <FullScreenContainer>
      <router-view />
    </FullScreenContainer>
  </div>
</template>

<script>
  import FullScreenContainer from "@/components/FullScreenContainer/index.vue";

  export default {
    components: {
      FullScreenContainer,
    },
  }
</script>

<style lang="scss" scoped>
#app {
  font-family: Noto Sans SC,Noto Sans SC-Medium,Noto Sans SC-Regular,Noto Sans SC-Bold;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 4px;
  height: 1px;
}
::-webkit-scrollbar-thumb {
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, .5);
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, .1);
}
</style>
